import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import apiService from '../../../features/api/service'
import { fetchBlog } from '../../../features/blog/slice'
import { FormVisibility as GenericForm } from '../../../features/visibility/components/form-visibility'
import { errorHandler } from '../../../utils'

const fieldKey = 'blog'

const FormVisibility = () => {
  const dispatch = useDispatch()
  const [requesting, setRequesting] = useState(false)
  const [errorMessage, setErrorMessage] = useState(null)
  const {
    id: blogId,
    visibility_id_only: defaultValue
  } = useSelector(state => state.blog.data)

  const handleSave = (newForm) => {
    if(requesting === false){
      console.log({newForm})

      setRequesting(true)
      setErrorMessage(null)

      apiService.update('blogs', blogId, newForm)
        .then(() => {
          toast.success('Successfully updated!')
          dispatch(fetchBlog(blogId))
        })
        .catch(err => {
          const msg = errorHandler(err)
          setErrorMessage(msg)
        })
        .finally(() => setRequesting(false))
    }
  }

  return (
    <div className="pb-8 lg:py-0 w-full">
      <GenericForm
        fieldKey={fieldKey}
        defaultValue={defaultValue}
        requesting={requesting}
        errorMessage={errorMessage}
        setErrorMessage={setErrorMessage}
        onSave={handleSave}
      />
    </div>
  )
}

export { FormVisibility }
